import { useAuth } from "@/core/hooks/useAuth";
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { RoutePaths } from "../constants/RoutePaths";
import { getPublicOnlyRedirect } from "@/core/auth/routeGuards";

const PublicOnlyRoute: React.FC = () => {
  const { isLoggedIn, user } = useAuth();

  const redirectTo = getPublicOnlyRedirect(isLoggedIn, user);

  if (redirectTo) {
    return (
      <Navigate
        to={redirectTo}
        replace
      />
    );
  }

  return isLoggedIn ? (
    <Navigate
      to={RoutePaths.CHATS}
      replace
    />
  ) : (
    <Outlet />
  );
};

export default PublicOnlyRoute;
